import { IconButton, Stack, Tooltip } from "@mui/material";
import { observer } from "mobx-react";
import { CombinatorRuleType } from "models/RuleCombinator";
import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import InfoIcon from "@mui/icons-material/Info";
import AcxButton from "components/UI/AcxButton";
import RBCFilterItem from "./RBCFilterItem";
import RBCFilterStore from "./RBCFilterStore";
import { blueButtonWhiteBackgroundStyle } from "utils/Style";
import { FilterLabel } from "../../shared";

interface Props {
    store: RBCFilterStore;
}

const RBCFilterInput: React.FunctionComponent<Props> = observer(
    ({ store }) => {
        const [isAddingItem, setIsAddingItem] = useState(false);

        const handleAdd = (combinator: CombinatorRuleType) => {
            store.addRBCFilterItem(combinator);
            setIsAddingItem(false);
        };

        const renderLabel = (
            <Stack direction="row" alignItems="center" flex={1}>
                <FilterLabel sx={{ mb: 0 }}>Classifiers</FilterLabel>
                <Tooltip title="If a classifier is new, we may not know if it's present in historical conversations. Those conversations will not be included in the results.">
                    <InfoIcon
                        sx={{
                            height: "16px",
                            width: "16px",
                            marginLeft: "4px",
                        }}
                        color="primary"
                    />
                </Tooltip>
            </Stack>
        );

        const renderAddBlockButton = (
            <IconButton
                size="small"
                onClick={() => {
                    if (store.RBCFilterItems.length === 0) {
                        store.addRBCFilterItem(0);
                    } else {
                        setIsAddingItem(true);
                    }
                }}
            >
                <AddIcon
                    sx={{
                        border: "1px solid #E4E4E7",
                        borderRadius: "4px",
                    }}
                />
            </IconButton>
        );

        const renderAddAndOrButtons = (
            <Stack direction="row" gap={1} mt={1}>
                <AcxButton
                    id="RBC-filter-input-add-and-button"
                    onClick={() => handleAdd(CombinatorRuleType.And)}
                    style={blueButtonWhiteBackgroundStyle}
                >
                    + AND
                </AcxButton>
                <AcxButton
                    id="RBC-filter-input-add-or-button"
                    onClick={() => handleAdd(CombinatorRuleType.Or)}
                    style={blueButtonWhiteBackgroundStyle}
                >
                    + OR
                </AcxButton>
            </Stack>
        );

        return (
            <>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ paddingBottom: 0.5 }}
                >
                    {renderLabel}
                    {renderAddBlockButton}
                </Stack>
                {store.RBCFilterItems.map((item, index) => (
                    <RBCFilterItem
                        item={item}
                        index={index}
                        key={index}
                        store={store}
                        classifierOptions={store.classifiersList}
                    />
                ))}
                {isAddingItem && renderAddAndOrButtons}
            </>
        );
    },
);

export default RBCFilterInput;
